import { useEffect, useState } from "react";
// Add FaChevronLeft, FaChevronRight to imports
import { FaSearch, FaBars, FaTimes, FaUser, FaShoppingCart, FaFacebookF, FaInstagram, FaTwitter, FaYoutube, FaArrowRight, FaChevronLeft, FaChevronRight } from 'react-icons/fa'
const Hero = ({ restaurant }) => {
  const [index, setIndex] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);

  const name = restaurant?.name || 'Bread & Sandwich'
  const color = restaurant?.primaryColor || '#ff6b00'
  const heroTitle = restaurant?.heroTitle || `${name}`
  const heroSubtitle = restaurant?.heroSubtitle || 'Fresh ingredients, handcrafted recipes, and unforgettable taste.'
  // Hero images: org-specified, or fall back to menu item images, or placeholder
  const menuImages = restaurant?.menu?.filter(i => i.imageUrl).map(i => i.imageUrl) || []
  const heroImagesFromOrg = restaurant?.heroImages || []
  const images = heroImagesFromOrg.length > 0 ? heroImagesFromOrg
    : menuImages.length > 0 ? menuImages.slice(0, 4)
    : ["/sandwich1.png", "/sandwich2.png", "/sandwich3.png"];

  
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 3500);

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#000',
      fontFamily: "'Arial', sans-serif"
    }}>

      {/* Main Content - Split Layout */}
      <main style={{
        minHeight: 'calc(100vh - 85px)',
        display: 'flex'
      }}>
        {/* Left Side - Text Content with Gradient */}
        <div style={{
          flex: 1,
          padding: '40px 40px 80px 40px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          background: 'linear-gradient(135deg, rgba(255, 107, 0, 0.1) 0%, rgba(255, 107, 0, 0.05) 50%, transparent 100%)',
          position: 'relative',
          overflow: 'hidden'
        }}>
          {/* Gradient Overlay */}
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'linear-gradient(90deg, rgba(255, 107, 0, 0.1) 0%, rgba(255, 107, 0, 0.05) 30%, transparent 70%)',
            zIndex: 1
          }}></div>
          
          <div style={{ position: 'relative', zIndex: 2 }}>
            {/* Main Heading */}
            <h1 style={{
              fontSize: '72px',
              fontWeight: 'bold',
              color: 'white',
              margin: '0 0 20px 0',
              lineHeight: '1.1',
              textShadow: '0 5px 15px rgba(0, 0, 0, 0.5)'
            }}>
              <span style={{ color: color, textShadow: `0 0 20px ${color}b0` }}>
                {heroTitle}
              </span>
            </h1>

            {/* Subtitle */}
            <p style={{
              fontSize: '22px',
              color: 'rgba(255, 255, 255, 0.8)',
              margin: '0 0 40px 0',
              maxWidth: '600px',
              lineHeight: '1.6'
            }}>
              {heroSubtitle}
            </p>

            {/* Call to Action */}
            <div style={{ display: 'flex', gap: '20px' }}>
              <button style={{
                backgroundColor: '#ff6b00',
                color: 'white',
                border: 'none',
                padding: '18px 45px',
                borderRadius: '30px',
                fontSize: '18px',
                fontWeight: '600',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '15px',
                boxShadow: '0 5px 25px rgba(255, 107, 0, 0.4)',
                transition: 'all 0.3s',
                ':hover': { 
                  transform: 'translateY(-3px)',
                  boxShadow: '0 8px 35px rgba(255, 107, 0, 0.6)'
                }
              }}>
                Order Now <FaArrowRight />
              </button>
              
              <button style={{
                backgroundColor: 'transparent',
                color: 'white',
                border: '2px solid rgba(255, 255, 255, 0.3)',
                padding: '18px 45px',
                borderRadius: '30px',
                fontSize: '18px',
                fontWeight: '600',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '15px',
                transition: 'all 0.3s',
                ':hover': {
                  borderColor: '#ff6b00',
                  color: '#ff6b00',
                  transform: 'translateY(-3px)'
                }
              }}>
Voir le Menu
              </button>
            </div>
          </div>
        </div>

        {/* Right Side - Image with Black Background */}
        <div style={{
          flex: 1,
          position: 'relative',
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: 'calc(100vh - 85px)'
        }}>
          {/* Black Background with Gradient Overlay */}
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'linear-gradient(to left, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 100%)',
            zIndex: 1
          }}></div>
          
          {/* Large Sandwich Image */}
          <div style={{
            position: 'relative',
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'center',
            zIndex: 2
          }}>
            <img 
              src={images[index]} 
              alt="sandwich" 
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
                filter: 'drop-shadow(0 40px 80px rgba(255, 107, 0, 0.2))',
                transition: 'opacity 0.5s ease, transform 0.6s ease',
              }}
            />
            
            {/* Glow Effect */}
            <div style={{
              position: 'absolute',
              width: '400px',
              height: '400px',
              background: 'radial-gradient(circle, rgba(255,107,0,0.3) 0%, rgba(255,107,0,0) 70%)',
              borderRadius: '50%',
              filter: 'blur(40px)',
              zIndex: -1
            }}></div>
          </div>

          {/* Image Navigation */}
          <div style={{
            position: 'absolute',
            bottom: '40px',
            left: '50%',
            transform: 'translateX(-50%)',
            display: 'flex',
            gap: '15px',
            zIndex: 10
          }}>
            {images.map((_, i) => (
              <button
                key={i}
                onClick={() => setIndex(i)}
                style={{
                  width: '60px',
                  height: '4px',
                  border: 'none',
                  backgroundColor: i === index ? '#ff6b00' : 'rgba(255,255,255,0.2)',
                  cursor: 'pointer',
                  transition: 'all 0.3s',
                  borderRadius: '2px',
                  position: 'relative',
                  overflow: 'hidden',
                  ':hover': { backgroundColor: '#ff6b00' }
                }}
                aria-label={`View sandwich ${i + 1}`}
              >
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  height: '100%',
                  width: i === index ? '100%' : '0%',
                  backgroundColor: '#ff6b00',
                  transition: 'width 3.5s linear'
                }}></div>
              </button>
            ))}
          </div>

          {/* Social Media Icons */}
          <div style={{
            position: 'absolute',
            right: '20px',
            top: '50%',
            transform: 'translateY(-50%)',
            display: 'flex',
            flexDirection: 'column',
            gap: '20px',
            zIndex: 10
          }}>
            {[
              { icon: <FaFacebookF />, color: '#1877F2' },
              { icon: <FaInstagram />, color: '#E4405F' },
              { icon: <FaTwitter />, color: '#1DA1F2' },
              { icon: <FaYoutube />, color: '#FF0000' }
            ].map((social, idx) => (
              <a
                key={idx}
                href="#"
                style={{
                  width: '45px',
                  height: '45px',
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white',
                  fontSize: '18px',
                  textDecoration: 'none',
                  transition: 'all 0.3s',
                  backdropFilter: 'blur(10px)',
                  ':hover': {
                    backgroundColor: social.color,
                    transform: 'translateX(-5px) scale(1.1)'
                  }
                }}
              >
                {social.icon}
              </a>
            ))}
          </div>
        </div>
      </main>

      {/* Mobile Menu */}
      {menuOpen && (
        <div style={{
          position: 'fixed',
          top: '85px',
          left: 0,
          right: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.95)',
          backdropFilter: 'blur(20px)',
          zIndex: 999,
          padding: '30px',
          borderTop: '1px solid rgba(255, 107, 0, 0.3)'
        }}>
          <ul style={{
            listStyle: 'none',
            margin: 0,
            padding: 0
          }}>
            {['Accueil', "Menu", 'À propos', 'Contact'].map((item) => (
              <li key={item} style={{ marginBottom: '20px' }}>
                <a 
                  href="#"
                  onClick={() => setMenuOpen(false)}
                  style={{
                    color: 'white',
                    textDecoration: 'none',
                    fontSize: '20px',
                    display: 'block',
                    padding: '15px 0',
                    borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                    transition: 'all 0.3s',
                    ':hover': {
                      color: '#ff6b00',
                      paddingLeft: '15px'
                    }
                  }}
                >
                  {item}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Mobile Responsive CSS - Pictures above text on mobile only */}
<style jsx>{`
  /* Mobile Responsive Styles - Force image on top */
  @media (max-width: 768px) {
    /* Force stacked layout on mobile */
    main {
      flex-direction: column !important;
      min-height: auto !important;
    }
    
    /* Image container - force to top */
    main > div:last-child {
      order: 1 !important;
      width: 100% !important;
      flex: none !important;
      height: 50vh !important;
      min-height: 50vh !important;
    }
    
    /* Text container - force to bottom */
    main > div:first-child {
      order: 2 !important;
      width: 100% !important;
      flex: none !important;
      height: 50vh !important;
      min-height: 50vh !important;
      padding: 20px !important;
    }
    
    /* Hide subtitle on mobile */
    main > div:first-child p {
      display: none !important;
    }
    
    /* Make image full width */
    main > div:last-child img {
      width: 100vw !important;
      height: 100% !important;
      object-fit: contain !important;
    }
    
    /* Center image */
    main > div:last-child > div {
      align-items: center !important;
      justify-content: center !important;
    }
    
    /* Adjust heading for mobile */
    main > div:first-child h1 {
      font-size: 36px !important;
      text-align: center !important;
      margin-top: 0 !important;
    }
    
    /* Center buttons */
    main > div:first-child > div > div {
      justify-content: center !important;
      flex-direction: column !important;
    }
    
    /* Make buttons full width on mobile */
    main > div:first-child button {
      width: 100% !important;
      max-width: 300px !important;
      justify-content: center !important;
    }
    
    /* Hide social icons on mobile */
    main > div:last-child > div:last-child {
      display: none !important;
    }
    
    /* Show mobile menu button */
    header button {
      display: block !important;
    }
    
    /* Hide desktop nav */
    header nav {
      display: none !important;
    }
    
    /* Adjust header for mobile */
    header > div {
      padding: 0 20px !important;
    }
    
    /* Adjust logo for mobile */
    header h1 {
      font-size: 20px !important;
    }
    
    header > div > div:first-child > div {
      width: 35px !important;
      height: 35px !important;
      font-size: 16px !important;
    }
  }
  
  /* Small mobile adjustments */
  @media (max-width: 480px) {
    main > div:last-child {
      height: 45vh !important;
      min-height: 45vh !important;
    }
    
    main > div:first-child {
      height: 55vh !important;
      min-height: 55vh !important;
    }
    
    main > div:first-child h1 {
      font-size: 32px !important;
    }
    
    main > div:last-child img {
      object-fit: cover !important;
    }
  }
  
  /* Very small mobile */
  @media (max-width: 360px) {
    main > div:last-child {
      height: 40vh !important;
      min-height: 40vh !important;
    }
    
    main > div:first-child {
      height: 60vh !important;
      min-height: 60vh !important;
    }
    
    main > div:first-child h1 {
      font-size: 28px !important;
    }
  }
  
  /* Tablet adjustments */
  @media (min-width: 769px) and (max-width: 1024px) {
    main > div:first-child h1 {
      font-size: 56px !important;
    }
    
    main > div:first-child p {
      font-size: 18px !important;
    }
    
    main > div:first-child button {
      padding: 16px 35px !important;
      font-size: 16px !important;
    }
  }
`}</style>
    </div>
  )
}

export default Hero